import type * as React from 'react';
import { patch } from '@Domain/Api';
import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';
import subjectUpdated, { type SubjectUpdatedAction } from '@Application/Subjects/Actions/subjectUpdated';
import subjectUpdateFailed, {
	type SubjectUpdateFailedAction,
} from '@Application/Subjects/Actions/subjectUpdateFailed';
import type UpdateSubject from '@Application/Subjects/Commands/UpdateSubject';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectUpdatedAction | SubjectUpdateFailedAction;

export default (command: UpdateSubject) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await patch<SubjectPayload>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/subjects/${command.subjectId}`,
				command.toJSON(),
			);

			const action = subjectUpdated(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
